import { defineFcm } from '../shared/factory';

export const FCM_SOCIAL_STARTER_IMAGE_PREWARM_ENABLED = defineFcm('social_starter_image_prewarm_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		supportedGroups: { global: true },
		context: 'Social Starter landing pages',
		description: 'Controls whether Social Starter pages prewarm AI petition images before claim.',
	});
